<template>
  <v-dialog
    v-model="visible"
    max-width="600"
    scrim="white"
    class="overlay-backdrop-filter"
  >
    <v-card class="notice-card pa-6" rounded="lg" elevation="6" data-testid="IndividualSubShutdownDialog">
      <div class="d-flex justify-end">
        <v-btn
          class="close-btn"
          append-icon="fa-solid fa-xmark"
          flat
          variant="text"
          size="small"
          data-testid="CloseTransient"
          @click="closeTransient"
        >
          Aizvērt
        </v-btn>
      </div>

      <div class="notice-body mt-2 text-center">
        <p>
          Sākot ar <strong>2026. gada 1. augustu</strong>, platformā Soma būs pieejami tikai izglītības iestāžu abonementi. Jūsu individuālais abonements tiks atcelts automātiski, un to varēs izmantot līdz pašreizējā abonementa beigām attiecīgajā mēnesī. Aicinām izmantot kolektīvos abonementus ar skolvadības pasēm. Ja jums šādas iespējas nav, lūdzu, sazinieties, rakstot uz <a href="mailto:soma@lielvards.lv">soma@lielvards.lv</a>.
        </p>
      </div>

      <div class="notice-actions d-flex justify-center align-center mt-5">
        <v-btn
          variant="outlined"
          rounded="pill"
          class="dismiss-btn font-weight-bold"
          data-testid="DismissPermanently"
          @click="dismissPermanently"
        >
          Iepazinos, vairāk nerādīt
        </v-btn>
        <v-btn
          variant="text"
          rounded="pill"
          class="more-btn ml-2"
          href="https://atbalsts.soma.lv/article/271-individualo-abonementu-izmainas"
          target="_blank"
          rel="noopener"
          data-testid="ReadMore"
        >
          Vairāk
        </v-btn>
        <v-btn
          variant="text"
          rounded="pill"
          class="abonementi-btn ml-2"
          data-testid="GoToSubscriptions"
          @click="goToSubscriptions"
        >
          Abonementi
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue"

import { useNoticesStore } from "~/stores/noticesStore"

export const INDIVIDUAL_SUB_NOTICE_ID = "individualSubShutdown"

export default defineComponent({
  setup() {
    const noticesStore = useNoticesStore()
    return { noticesStore }
  },

  data() {
    return {
      visible: true,
    }
  },

  methods: {
    closeTransient() {
      this.noticesStore.skipForSession(INDIVIDUAL_SUB_NOTICE_ID)
      this.visible = false
    },

    dismissPermanently() {
      this.noticesStore.dismissPermanently(INDIVIDUAL_SUB_NOTICE_ID)
      this.visible = false
    },

    goToSubscriptions() {
      this.noticesStore.skipForSession(INDIVIDUAL_SUB_NOTICE_ID)
      this.visible = false
      navigateTo("/profile/abonements")
    },
  },
})
</script>

<style lang="sass" scoped>
.overlay-backdrop-filter
  backdrop-filter: blur(7px)

.notice-card
  width: 100%

.notice-body
  font-size: 17px
  line-height: 1.5
  color: #221B00

.close-btn
  text-transform: none
  font-size: 14px
  color: #6b6b6b
  letter-spacing: 0

.dismiss-btn
  text-transform: none
  font-size: 15px
  letter-spacing: 0
  border-color: #221B00
  color: #221B00

.more-btn
  text-transform: none
  font-size: 15px
  letter-spacing: 0
  color: #6b6b6b

.abonementi-btn
  text-transform: none
  font-size: 15px
  letter-spacing: 0
  color: #6b6b6b
</style>
